import script from "./MajorSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./MajorSearch.vue?vue&type=script&setup=true&lang=js"

import "./MajorSearch.vue?vue&type=style&index=0&id=df54df9a&scoped=true&lang=css"

import exportComponent from "D:\\code\\frontEndCode\\collegeSubjectPage\\page\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-df54df9a"]])

export default __exports__